<template>
    <div v-cloak class="contract-verification-result">
        <ContractBodyComponent v-if="contractDetails" :contractDetails="contractDetails" />
        <!--<ContractActionsComponent :contractDetails="contractDetails" @click:action="onHandleAction($event)" />-->
        <button class="btn btn-outline-primary mx-4 px-4 float-left"
                @click="onHandleAction('DownloadContract')">
            <i class="fal fa-sign-in fa-rotate-90 ml-2"></i>تحميل
            وثيقة العقد
        </button>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';
    import { Inject } from 'vue-di-container';

    import ContractService from '@/services/contract.service';
    import { ContractModel } from '@/models/contract.model';
    import { ContractAction as Action } from '@/models/actions.models';
    import ContractActionsComponent from '@/components/contract/contract-actions.component.vue';
    import ContractBodyComponent from '@/components/contract/contract-body.component.vue';
    import { string } from 'yup';

    @Component({
        components: {
            ContractBodyComponent,
            ContractActionsComponent,
        },
        diProvide: [
            ContractService,
        ],
    })
    export default class ContractVerificationResult extends Vue {
        @Inject(ContractService) public contractService!: ContractService;
        contractDetails: ContractModel = {} as ContractModel;
        partnerSocialId: string = '';
        created() {
            const contract = sessionStorage.getItem('contract');
          
            if (contract) {
                this.contractDetails = JSON.parse(contract) as ContractModel;
            }


        }
        //mounted() {
        //  const contract = sessionStorage.getItem('contract');
        //  if (contract) {
        //    this.contractDetails = JSON.parse(contract) as ContractModel;
        //  }
        //}

        /**
         * Handles the various view actions.
         * @param action The action to be performed.
         * @returns void
         */
        onHandleAction(action: Action): void {
            if (action !== 'DownloadContract') return;
            this.partnerSocialId = this.contractDetails?.partners[0].socialId;
            this.downloadContract(this.contractDetails.contractCode);
        }

        private downloadContract(contractCode: number | null): void {
            if (!contractCode) return;

            this.contractService.getContractAsPDF(contractCode, this.partnerSocialId).then((res) => {
                const linkSource = `data:application/pdf;base64,${res.model}`;
                const downloadLink = document.createElement('a');
                const fileName = `${contractCode}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
        }
    }
</script>
